import { Link } from 'react-router-dom';
import type { SpecialItem } from '@/types';

interface SpecialPreviewProps {
  items: SpecialItem[];
}

export default function SpecialPreview({ items }: SpecialPreviewProps) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {items.map((item) => (
        <Link
          key={item.id}
          to={`/specials/${item.id}`}
          className="group relative overflow-hidden rounded-lg border border-accent-700/40 bg-accent-50"
        >
          <div className="relative h-48 w-full overflow-hidden md:h-60">
            <img
              src={item.cover}
              alt={item.title}
              title={`${item.title} - 电影专题合集`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-accent-50 via-accent-50/60 to-transparent" />
          </div>
          <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
            <span className="eyebrow inline-flex rounded bg-primary-500/95 px-2 py-0.5 text-[10px] text-background-50">
              {item.tag}
            </span>
            <h3 className="mt-2 font-heading text-xl tracking-wide text-foreground-950 md:text-2xl">{item.title}</h3>
            <p className="mt-1.5 line-clamp-2 text-xs leading-6 text-foreground-600">{item.description}</p>
            <span className="mt-3 inline-flex items-center gap-1 text-[11px] text-primary-500">
              共 {item.movieIds.length} 部影片
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}